import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75a49e84"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["width", "height"]
const _hoisted_2 = {
  fill: "none",
  "fill-rule": "evenodd"
}
const _hoisted_3 = { transform: "translate(1 1)" }
const _hoisted_4 = ["stroke", "stroke-width"]
const _hoisted_5 = ["dur"]

import { computed, PropType, toRaw } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseSpinner',
  props: {
  show: {
    type: Boolean,
    required: false,
    default: true,
  },
  size: {
    type: Number,
    required: false,
    default: 18,
  },
  thickness: {
    type: Number,
    required: false,
    default: 1.5,
  },
  speed: {
    type: Number,
    required: false,
    default: 0.7,
  },
  center: {
    type: Boolean,
    required: false,
    default: false,
  },
  color: {
    type: String,
    required: false,
    default: "currentColor",
  },
  preset: {
    type: String as PropType<"large">,
    required: false,
    default: undefined,
  },
},
  setup(__props) {

const props = __props



let center = false;
let color: string;
let size: number;
let thickness: number;
let speed: number;

if (props.preset === "large") {
  center = true;
  color = "var(--blue)";
  size = 64;
  ({ thickness, speed } = toRaw(props));
} else {
  ({ center, color, size, thickness, speed } = toRaw(props));
}

const spinnerStyle = computed(() => ({
  display: center ? "block" : "inline-block",
  margin: center ? "0 auto" : "0",
}));

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("svg", {
    width: _unref(size),
    height: _unref(size),
    style: _normalizeStyle(_unref(spinnerStyle)),
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    class: "spinner"
  }, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("g", _hoisted_3, [
        _createElementVNode("path", {
          d: "M36 18c0-9.94-8.06-18-18-18",
          stroke: _unref(color),
          "stroke-width": _unref(thickness)
        }, [
          _createElementVNode("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 18 18",
            to: "360 18 18",
            dur: `${_unref(speed)}s`,
            repeatCount: "indefinite"
          }, null, 8, _hoisted_5)
        ], 8, _hoisted_4)
      ])
    ])
  ], 12, _hoisted_1)), [
    [_vShow, __props.show]
  ])
}
}

})